import type { PaymentFailureDetails } from './types';
import styles from './PaymentFailureDetailsCard.module.css';

export interface PaymentFailureDetailsCardProps {
	details: PaymentFailureDetails;
}

export const PaymentFailureDetailsCard = ({ details }: PaymentFailureDetailsCardProps) => {
	return (
		<div className={styles.card}>
			<div className={styles.statusRow}>
				<span className={styles.label}>Status da Transação</span>
				<span className={styles.status}>{details.status.toUpperCase()}</span>
			</div>
			<ul className={styles.reasonList}>
				{details.reasons.map((reason) => (
					<li key={reason} className={styles.reasonItem}>
						<span className={styles.bullet} />
						<span className={styles.reasonText}>{reason}</span>
					</li>
				))}
			</ul>
		</div>
	);
};
